import {Component, Input, OnInit} from '@angular/core';
import {
    BaseStepperFormComponent,
    LoadingService,
    MembershipProgram,
    MembershipProgramFeeStructure,
    MembershipProgramService,
    Menu,
    MenuService,
    Organization,
    OrganizationService,
    ToastService
} from 'brewbill-lib';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ModalController} from '@ionic/angular';

@Component({
    selector: 'bb-edit-membership-program',
    templateUrl: './edit-membership-program.component.html',
    styleUrls: ['./edit-membership-program.component.scss'],
})
export class EditMembershipProgramComponent extends BaseStepperFormComponent implements OnInit {
    @Input() membershipProgram: MembershipProgram;

    organization: Organization;
    menu: Menu;
    formGroup: FormGroup;

    constructor(
        modalController: ModalController,
        private membershipProgramService: MembershipProgramService,
        private menuService: MenuService,
        private organizationService: OrganizationService,
        private loadingService: LoadingService,
        private toastService: ToastService,
        private formBuilder: FormBuilder
    ) {
        super(modalController);
    }

    ngOnInit() {
        this.menu = this.menuService.currentValue;
        this.organization = this.organizationService.currentValue;

        const taxLabels = !!this.membershipProgram && !!this.membershipProgram.taxLabels && !!this.menu && !!this.menu.menuTaxLabels ?
            this.menu.menuTaxLabels.filter(m => this.membershipProgram.taxLabels.some(t => t.id === m.id))
            : null;

        this.formGroup = this.formBuilder.group({
            id: !!this.membershipProgram && !!this.membershipProgram.id ? this.membershipProgram.id : null,
            parentId: !!this.organization ? this.organization.id : null,
            name: [!!this.membershipProgram ? this.membershipProgram.name : null, Validators.required],
            description: !!this.membershipProgram ? this.membershipProgram.description : null,
            amount: [!!this.membershipProgram ? this.membershipProgram.amount : null, Validators.required],
            durationPart: [!!this.membershipProgram ? this.membershipProgram.durationPart : 'YEAR', Validators.required],
            durationCount: [!!this.membershipProgram ? this.membershipProgram.durationCount : 1, Validators.required],
            autoRenewal: !!this.membershipProgram && this.membershipProgram.autoRenewal,
            lifetime: !!this.membershipProgram && this.membershipProgram.lifetime,
            status: !!this.membershipProgram ? this.membershipProgram.status : 'ACTIVE',
            tokens: !!this.membershipProgram ? this.membershipProgram.tokens : 0,
            tokensExpire: !this.membershipProgram || this.membershipProgram.tokensExpire,
            useTokens: !!this.membershipProgram && !!this.membershipProgram.tokens,
            sendLowTokenEmail: !this.membershipProgram || this.membershipProgram.sendLowTokenEmail,
            lowTokenEmailThreshold: !!this.membershipProgram ? this.membershipProgram.lowTokenEmailThreshold : null,
            taxTokenPayments: !this.membershipProgram || this.membershipProgram.taxTokenPayments,
            feeStructure: !!this.membershipProgram ? this.membershipProgram.feeStructure : MembershipProgramFeeStructure.NO_ORG,
            continuousRenewalDate: !!this.membershipProgram && this.membershipProgram.continuousRenewalDate,
            expirationEmailDuration: [
                !!this.membershipProgram ? this.membershipProgram.expirationEmailDuration : 'NONE', Validators.required
            ],
            expirationEmailDurationCount: !!this.membershipProgram ? this.membershipProgram.expirationEmailDurationCount : 1,
            taxLabels: [taxLabels]
        });

        this.formGroup.get('useTokens').valueChanges.subscribe(value => {
            if (value) {
                this.formGroup.get('tokens').setValidators([Validators.required]);
            } else {
                this.formGroup.get('tokens').setValidators([]);
                this.formGroup.get('tokens').setValue(null);
            }

            this.formGroup.get('tokens').updateValueAndValidity();
        });
    }

    onSubmit() {
        if (this.formGroup.valid) {
            const membershipProgram = new MembershipProgram(this.formGroup.value);
            this.loadingService.present();
            if (!membershipProgram.id) {
                this.membershipProgramService.create(membershipProgram).subscribe(c => {
                    this.loadingService.dismiss();
                    this.close(new MembershipProgram(c));
                });
            } else {
                this.membershipProgramService.update(membershipProgram).subscribe(c => {
                    this.loadingService.dismiss();
                    this.close(new MembershipProgram(c));
                }, error => {
                    if (error.status === 422) {
                        this.toastService.error('The membership program is out of sync from a previous change. Please refresh to make changes.');
                    }
                });
            }
        }
    }
}
